// @flow
import React, { Component, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import moment from 'moment';
import classNames from 'classnames/bind';
import Modal from '../../../../../elements/Modal/Modal';

import style from './StatusBoard.scss';
import icons from '../../../../../assets/styles/icons.scss';

import type {
  BagItem,
  LastMileShipping,
  OrderItem,
  OrderItemCancellation,
  ShoppingCartItem,
} from '../../../../../entities';
import type { LocaleState } from '../../../../locale/duck';

type Props = {
  +localeState: LocaleState;
  +lastMileShippings?: LastMileShipping[];
  +items: OrderItem;
};

type State = {
  openModal: boolean;
  lastMileShipping?: LastMileShipping;
};

type Item = BagItem | ShoppingCartItem;

export default class StatusBoard extends Component<Props, State> {
  state = {
    openModal: false,
    lastMileShipping: undefined,
  };

  constructor(props: Props): void {
    super(props);
  }

  handleOpenModal = (lms: LastMileShipping) => {
    this.setState({
      openModal: true,
      lastMileShipping: lms,
    });
  };

  handleCloseModal = () => {
    this.setState({ openModal: false });
  };

  buildLastMileShippingStatus = () => {
    const { lastMileShippings } = this.props;
    return (!!lastMileShippings &&
      <Fragment>
        <FormattedMessage id="order.statusBoard.title.delivered">{
          txt => <p className={style.title}>{txt}</p>
        }</FormattedMessage>
        {lastMileShippings.map((lms: LastMileShipping, n: number) => (
          <section key={n}
                   className={style.orderWrapper}>
            <section className={style.title}>
              <p>{moment(lms.date).utc().format('MMM DD')} - {lms.courier.name}</p>
              <FormattedMessage id="order.statusBoard.shipped.tracking">{
                txt => <p className={style.tracking}
                          onClick={() => this.handleOpenModal(lms)}>{txt}</p>
              }</FormattedMessage>
            </section>
            {lms.items.map((item: Item, n: number) => (
              <section key={`${n}-${item.amount}`}
                       className={style.itemLine}>
                <section className={style.amountWrap}>
                  <p className={style.amount}>{item.amount}</p>
                </section>
                <p className={style.name}>{item.orderItem.name}</p>
              </section>
            ))}
          </section>))}
      </Fragment>);
  };

  buildCancellations = () => {
    const { localeState, items } = this.props;
    const hasCancellations = items.some((item: OrderItem) => !!item.cancelledCount);
    return (hasCancellations &&
      <Fragment>
        <FormattedMessage id="order.statusBoard.title.canceled">{
          txt => <p className={classNames(style.title, style.red)}>{txt}</p>
        }</FormattedMessage>
        {items.map((item: OrderItem) => (
          item.cancellations && item.cancellations.map((cancellation: OrderItemCancellation, n: number) =>
            <section key={n}
                     className={style.orderWrapper}>
              <section key={`${n}-${cancellation.amount}`}
                       className={style.itemLine}>
                <section className={style.amountWrap}>
                  <p className={style.amount}>{cancellation.amount}</p>
                </section>
                <p className={style.name}>{item.name}</p>
              </section>
              <FormattedMessage id="order.statusBoard.reason">{
                txt => <p
                  className={style.reason}>{txt} {cancellation.motive.translations[localeState.locale.toUpperCase()]}</p>
              }</FormattedMessage>
            </section>,
          )))}
      </Fragment>)
  };

  render() {
    const { lastMileShippings, items } = this.props;
    const { openModal, lastMileShipping } = this.state;
    const hasCancellations = items.some((item: OrderItem) => !!item.cancelledCount);
    return (
      <Fragment>
        {((!!lastMileShippings && lastMileShippings.length > 0) || hasCancellations) &&
        <section className={style.statusBoardWrapper}>
          {this.buildLastMileShippingStatus()}
          {this.buildCancellations()}
        </section>}
        <Modal handleClose={this.handleCloseModal}
               open={openModal}
               big
               closeOnEsc>
          {!!lastMileShipping &&
          <section className={style.propertiesWrap}>
            <FormattedMessage id="order.statusBoard.modal.deliveryDate">{
              txt => <p className={style.title}>{txt} - {moment(lastMileShipping.date).utc().format('MMM DD')}</p>
            }</FormattedMessage>
            <FormattedMessage id="order.statusBoard.modal.courier">{
              txt => <p className={style.subtitle}>{txt}:</p>
            }</FormattedMessage>
            <p>{lastMileShipping.courier.name}</p>
            {!!lastMileShipping.trackingNumber &&
            <FormattedMessage id="order.statusBoard.modal.trackingNumber">{
              txt => <p className={style.subtitle}>{txt}:</p>
            }</FormattedMessage>}
            {!!lastMileShipping.trackingNumber &&
            <p>{lastMileShipping.trackingNumber}</p>}
            {!!lastMileShipping.image &&
            <FormattedMessage id="order.statusBoard.modal.seeInvoice">{
              txt => <a className={style.invoice}
                        href={lastMileShipping.image}
                        target="_blank"><i className={icons.symbolDocument}/>{txt}</a>
            }</FormattedMessage>}
            <br/>
            <br/>
            <FormattedMessage id="order.statusBoard.modal.howToTack">{
              txt => <a 
                className={style.howTo}
                href="https://help.qempo.com/article/9xp7l3ae0g-c-mo-hacer-seguimiento-al-env-o-final-de-mi-pedido" 
                target="_blank">
                {txt}
              </a>
            }</FormattedMessage>
          </section>}
        </Modal>
      </Fragment>);
  }

}

StatusBoard.propTypes = {
  localeState: PropTypes.object.isRequired,
  lastMileShippings: PropTypes.array,
  items: PropTypes.array.isRequired,
};





// WEBPACK FOOTER //
// ./src/modules/order/Purchase/components/StatusBoard/StatusBoard.jsx